import React from 'react';
import { ColorValue, StatusTone } from '../../types';
import { colorCssVars, TONE_FALLBACK_LABELS, legacyStatusTone } from '../../utils/statusColors';
import './DataCard.css';

interface DataCardProps {
  value: string | number;
  colorStatus: ColorValue;
  statusTone?: StatusTone;
  /** When set, replaces status-based styling with this single color */
  customColor?: string;
  units?: string;
  label?: string;
  statusLabel?: string;
}

export const DataCard: React.FC<DataCardProps> = ({
  value,
  colorStatus,
  statusTone = legacyStatusTone(colorStatus),
  customColor,
  units,
  label,
  statusLabel
}) => {
  const formatNumber = (num: number): string => {
    // Add comma separators for big numbers
    const addCommas = (numStr: string): string => {
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    
    // Only show decimals if the number has meaningful decimal places
    if (num % 1 === 0) {
      return addCommas(num.toString()); // No decimals for whole numbers
    }
    return addCommas(num.toFixed(2)); // 2 decimals for decimal numbers
  };

  const getStatusText = () => {
    if (customColor) return 'Tracking';
    return TONE_FALLBACK_LABELS[statusTone];
  };

  return (
    <div
      className={`data-card${customColor ? ' data-card--custom' : ''}`}
      style={customColor ? ({ '--data-card-color': customColor } as React.CSSProperties) : colorCssVars(colorStatus)}
    >
      <div className="data-card__main">
        <div className="data-card__value">
          {typeof value === 'number' ? formatNumber(value) : value}{units ? ` ${units}` : ''}
        </div>
        {label && (
          <div className="data-card__label">
            {label}
          </div>
        )}
      </div>
      
      <div className="data-card__status">
        <span className="data-card__status-text">
          {statusLabel || getStatusText()}
        </span>
      </div>
    </div>
  );
};
